import React from 'react';
import AmountInputComponent from './AmountInputComponent';
import AmountInputRiskAnalysis from '../../../../../../risk-analysis/src/components/input/AmountInputComponent';
import {
  isCustomerCheckupFlow,
  isRiskAnalysisFlow,
} from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const AmountInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (isRiskAnalysisFlow() || isCustomerCheckupFlow())
    return <AmountInputRiskAnalysis question={question} />;
  return <AmountInputComponent question={question} />;
};

export default AmountInputPicker;
